<template>
  <div>
    <el-menu class="el-menu leftMenu" :default-active="tacit" active-text-color="" text-color="#6a6a6a"
      :default-openeds="openeds" @select="handleSelect">
      <el-submenu index="1">
        <template slot="title">
          <span>PS模型进度</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :class="Selected == 1 ? 'selected' : ''" index="1">原始素材</el-menu-item>
          <el-menu-item style="font-weight: 600" :class="Selected == 2 ? 'selected' : ''" index="2">上架中</el-menu-item>
          <el-menu-item :class="Selected == 3 ? 'selected' : ''" index="3">下架中</el-menu-item>
          <el-menu-item :class="Selected == 4 ? 'selected' : ''" index="4">回收站</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title">
          <span>PS模型分类</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :class="Selected2 == '/Material_noe' ? 'selected' : ''" index="/Material_noe">未分类</el-menu-item>
          <el-menu-item :class="Selected2 == '/PSpeople' ? 'selected' : ''" index="/PSpeople">人</el-menu-item>
          <el-menu-item :class="Selected2 == '/PSoriginal' ? 'selected' : ''" index="/PSoriginal">植物</el-menu-item>
          <!-- <el-menu-item :class="Selected2 == '/PS_Sky' ? 'selected' : ''" index="/PS_Sky">天空</el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Selected2: "/",
        tacit: "/",

        openeds: ["1", "2", "3"],
      };
    },
    computed: {
      Selected: {
        get() {
          return this.$store.getters.PSprocess;
        },
        set() { },
      },
    },
    created() {
      //   this.tacit =this.$route.path
      if (sessionStorage.getItem("Selected2")) {
        this.tacit = sessionStorage.getItem("Selected2");
      } else {
        this.tacit = "/PSpeople";
      }
      if (sessionStorage.getItem("Selected2")) {
        this.Selected = sessionStorage.getItem("Selected2");
      }
    },
    destroyed() {
      sessionStorage.removeItem('Selected2')
      sessionStorage.removeItem('Selected')
    },

    mounted() { },
    methods: {
      handleSelect(e) {
        if (e == 1 || e == 2 || e == 3 || e == 4 || e == 5) {
          this.$store.dispatch("setPSprocess", e);
          sessionStorage.setItem("Selected", e);
          this.Selected = e;
          if (!sessionStorage.getItem("Selected2")) {
            this.Selected2 = "/PSpeople";
          }
          return;
        }
        if (this.Selected2 == e) {
          return;
        }
        // this.Selected = 2;
        // this.$store.dispatch("setPSprocess", 2);
        this.Selected2 = `${e}`;
        sessionStorage.setItem("Selected2", e);
        this.$router.push(e);
      },
    },
  };
</script>

<style scoped>
  .el-aside .el-menu {
    width: 100%;
    min-height: 100%;
    border: none;
    margin: 0 2%;
    font-weight: normal;
  }

  .el-dropdown-menu__item,
  .el-menu-item {
    font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
    font-size: 12px;
    height: 30px !important;
    line-height: 30px !important;
    width: 95%;
    margin-top: 1px;
    padding: 0 40px;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    border-radius: 8px;
    background-color: rgba(233, 244, 254, 1);
  }

  .el-menu-demo .el-menu-item:hover {
    border-radius: 0px;
  }

  .selected {
    background-color:#F0F0F0 ;
    color: #6a6a6a !important;
    border-radius: 8px;
  }

  .el-menu-demo .el-menu-item {
    border-radius: 0;
  }

  .el-aside .is-active {
  border-radius: 8px;
  background-color:#F0F0F0 ;
  color: #6a6a6a;
}
.leftMenu .el-menu-item.is-active{
    background-color: #F0F0F0 !important;
  }

  .menu_scroll {
    overflow-x: hidden;
  }

  >>>.el-submenu__title {
    font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
    font-size: 12px !important;
    height: 40px;
    line-height: 40px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/material/MaterialMun.vue